// Конфигурация стилей с превью-изображениями
// Headman - расширенный каталог стрижек

export type HairLength = "short" | "medium" | "long";
export type HairVibe = "classic" | "modern" | "messy" | "disconnected";

export interface HairstyleConfig {
    id: string;
    title: string; // Название на русском
    label: string; // Для обратной совместимости
    description: string; // Prompt для AI
    previewImage?: string; // Путь к превью-изображению
    tags?: string[]; // Теги на русском
    shortDescription?: string; // Краткое описание на русском
    variations?: string; // Вариации на русском
    length?: HairLength; // Длина волос
    vibe?: HairVibe; // Стиль/настроение
    hiddenInCatalog?: boolean; // Скрыть из каталога
}

export const HAIRSTYLE_CONFIGS: HairstyleConfig[] = [
    // === НОВЫЕ СТИЛИ HEADMAN ===
    {
        id: "quiff",
        title: "Квифф",
        label: "Quiff",
        description: "Quiff hairstyle, volume forward and up, short faded sides, modern barbershop cut",
        previewImage: "/styles/catalog/quiff.png",
        tags: ["Объёмная", "Динамичная"],
        shortDescription: "Объём вверх и вперёд с короткими висками. Динамичная стрижка для активных и стильных.",
        variations: "Небрежный / Текстурный / Аккуратный",
        length: "medium",
        vibe: "modern"
    },
    {
        id: "flow",
        title: "Флоу кат",
        label: "Flow Cat",
        description: "Flow haircut, medium length swept back, hockey hair, natural movement",
        previewImage: "/styles/catalog/flow.png",
        tags: ["Естественная", "Спортивная"],
        shortDescription: "Волосы средней длины с естественным потоком назад. Популярна среди хоккеистов и спортсменов.",
        variations: "Короткий flow / Средний / Длинный",
        length: "medium",
        vibe: "modern"
    },
    {
        id: "fringe",
        title: "Френдж кат",
        label: "Fringe Cat",
        description: "Fringe cut, textured bangs, modern fringe hairstyle",
        previewImage: "/styles/catalog/fringe.png",
        tags: ["Молодёжная", "Трендовая", "С чёлкой"],
        shortDescription: "Стрижка с текстурной чёлкой вперёд. Модный и современный образ.",
        variations: "Текстурная / Прямая / Рваная",
        length: "medium",
        vibe: "modern"
    },
    {
        id: "gent",
        title: "Гент",
        label: "Gent",
        description: "Gentleman haircut, refined style, classic elegant cut",
        previewImage: "/styles/catalog/gent.png",
        tags: ["Деловая", "Элегантная", "Классика"],
        shortDescription: "Классическая элегантная стрижка для настоящих джентльменов. Утончённый стиль.",
        variations: "Классический / С пробором / Зачёс назад",
        length: "medium",
        vibe: "classic"
    },
    {
        id: "middle_part",
        title: "Мидл парт",
        label: "Middle Part",
        description: "Middle part hairstyle, center parting, modern styling",
        previewImage: "/styles/catalog/middle_part.png",
        tags: ["Молодёжная", "Трендовая"],
        shortDescription: "Пробор посередине с волосами на две стороны. Популярный молодёжный тренд.",
        variations: "Короткий / Средний / Длинный",
        length: "medium",
        vibe: "modern"
    },
    {
        id: "mod",
        title: "Мод кат",
        label: "Mod Cat",
        description: "Mod cut, contemporary style, modern fashionable haircut",
        previewImage: "/styles/catalog/mod.png",
        tags: ["Модная", "Современная", "Трендовая"],
        shortDescription: "Модная современная стрижка для тех, кто следит за трендами. Актуальный стиль.",
        variations: "Классический / Текстурный / Дерзкий",
        length: "medium",
        vibe: "modern"
    },
    {
        id: "oxford",
        title: "Оксфорд",
        label: "Oxford",
        description: "Oxford cut, traditional english style, classic british haircut",
        previewImage: "/styles/catalog/oxford.png",
        tags: ["Классика", "Элегантная", "Британская"],
        shortDescription: "Классическая британская стрижка в традиционном стиле. Элегантность и сдержанность.",
        variations: "Классический / С пробором / Аккуратный",
        length: "medium",
        vibe: "classic"
    },
    {
        id: "warrior",
        title: "Варриор кат",
        label: "Warrior Cat",
        description: "Warrior cut, bold masculine style, daring haircut",
        previewImage: "/styles/catalog/warrior.png",
        tags: ["Дерзкая", "Мужественная", "Смелая"],
        shortDescription: "Дерзкая мужественная стрижка для смелых и уверенных. Воинственный стиль.",
        variations: "Короткий / Текстурный / Агрессивный",
        length: "short",
        vibe: "modern"
    },
    
    // === КЛАССИЧЕСКИЕ СТИЛИ ===

    {
        id: "mullet",
        title: "Маллет",
        label: "Mullet",
        description: "Modern mullet haircut, short on top and sides, longer in back, business in front party in back",
        previewImage: "/styles/catalog/mullet.jpg",
        tags: ["Дерзкая", "Ретро", "Трендовая"],
        shortDescription: "Короткий верх и бока с удлинённым затылком. Стрижка для смелых — снова на пике моды.",
        variations: "Классический / Современный / Текстурный",
        length: "long",
        vibe: "modern"
    },
    {
        id: "caesar",
        title: "Цезарь",
        label: "Caesar",
        description: "Caesar cut, short horizontal fringe, uniform length, clean classic look",
        previewImage: "/styles/catalog/caesar.jpg",
        tags: ["Классика", "Практичная"],
        shortDescription: "Короткая стрижка с горизонтальной чёлкой. Минималистичный стиль, не требующий сложной укладки.",
        variations: "Классический / Текстурный / С фейдом",
        length: "short",
        vibe: "classic"
    },
    {
        id: "crop",
        title: "Кропп",
        label: "Crop",
        description: "Short french crop with blunt fringe and faded sides, textured top, contemporary barbershop style",
        previewImage: "/styles/catalog/crop.jpg",
        tags: ["Текстурная", "Модная"],
        shortDescription: "Текстурный верх с ровной или рваной чёлкой. Практичная и стильная стрижка для повседневного образа.",
        variations: "Классический / Текстурный / С чёлкой",
        length: "short",
        vibe: "modern"
    },
    {
        id: "curly_volume",
        title: "Кудрявый объём",
        label: "Curly volume",
        description: "Medium-length curly hair with natural volume, defined curls (not afro-like), barbershop styling",
        previewImage: "/styles/catalog/curly_volume.webp",
        tags: ["Кудрявая", "Натуральная", "Объёмная"],
        shortDescription: "Объёмная стрижка для натуральных кудрей. Подчёркивает текстуру и естественную красоту волос.",
        variations: "Короткие кудри / Средний объём / Максимальный",
        length: "medium",
        vibe: "modern"
    },
    {
        id: "buzz",
        title: "Buzz Cut (Баз кат)",
        label: "Buzz Cut",
        description: "Buzz cut hairstyle, very short clipper cut, clean and low maintenance, classic barbershop cut",
        previewImage: "/styles/catalog/buzz.jpg",
        tags: ["Универсальная", "Практичная", "Минималистичная"],
        shortDescription: "Короткая стрижка машинкой — универсальный выбор для тех, кто ценит практичность и стиль.",
        variations: "Лысина (под ноль) / Buzz Cut / Отросший Buzz Cut",
        length: "short",
        vibe: "classic"
    }
];

// Маппинг ID из API к ID в конфиге (для обратной совместимости)
export const STYLE_ID_MAP: Record<string, string> = {
    "curlyvolume": "curly_volume",
    "curly-volume": "curly_volume",
    "curly": "curly_volume",
    "flow_cat": "flow",
    "fringe_cat": "fringe",
    "mod_cat": "mod",
    "warrior_cat": "warrior",
    "buzz_cut": "buzz",
    "flow_cut": "flow",
    "textured_crop": "crop",
    "side_part": "oxford",
};

// Функция для получения конфига по ID (с учётом маппинга)
export function getHairstyleConfig(id: string): HairstyleConfig | undefined {
    const mappedId = STYLE_ID_MAP[id] || id;
    return HAIRSTYLE_CONFIGS.find(h => h.id === mappedId);
}

// ID стилей для быстрых пресетов (ключевые стили HEADMAN)
export const QUICK_STYLE_IDS = [
    'quiff',
    'flow', 
    'fringe',
    'gent',
    'middle_part',
    'mod'
];

